<template>
  <div v-if="showBanner" class="top-banner">
    NOTE: Bookings will only be enabled on the actual day of Open House itself
    (16 May)
  </div>

  <Transition>
    <Dialog
      v-if="showDialog"
      title="About"
      message="This site was built by a team of Year 4 to 6 students in NUS High School,
      composed of Lee Jia Jie, Tan Kai Xun Dave, Tan Yong Tat, Dedeep Sai Vadapalli, 
      Lim Teck Kong and Prannaya Gupta, and maintained by Wong Yue Heng and Yu Simu, 
      with support from the NUS High Students' Council and AppVenture, 
      the Computer Science Interest Group of NUS High."
      @close="showDialog = false"
    />
  </Transition>
  <div class="welcome">
    <img src="@/assets/img/school_logo.png" height="54" width="100" />
    <h1>NUS High School Tour</h1>
    <p>
      The tour will take about 30 minutes, giving you an overview of our
      school's facilities.
    </p>
    <div style="height: 18px"></div>
    <p>
      Please register for a timeslot to attend a tour. Each booking can
      accommodate up to 4 persons and you can only book up to 45 minutes before
      the tour. Please make multiple bookings if you have more than 4 people.
    </p>
    <div style="height: 18px"></div>
    <p>
      Do note that tours involve climbing of stairs. If you require assistance
      please inform you guide before the start of the tour
    </p>
    <div style="height: 50px"></div>
    <MyButton text="Sign up" :onClick="signUp" :disabled="showBanner" />
    <div style="height: 4px"></div>
    <OutlinedButton text="Toggle Font Size" :onClick="toggleFontSize" />
    <div class="spacer"></div>
    <span class="credits" @click="showDialog = true">
      By Jia Jie, Dave, Yong Tat, Sai, Teck Kong, Prannaya; maintained by Yue
      Heng, Simu
    </span>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import MyButton from '@/components/MyButton.vue';
import OutlinedButton from '@/components/OutlinedButton.vue';
import Dialog from '@/components/Dialog.vue';
import { bigFontSize } from '@/states';

export default {
  components: {
    MyButton,
    OutlinedButton,
    Dialog,
  },
  setup() {
    const router = useRouter();
    const showDialog = ref(false);
    //const cutoffDate = new Date('2026-05-16');

    const showBanner = computed(() => {
      return false; //return new Date() < cutoffDate;
    });

    function signUp() {
      router.push('/select-timing');
    }
    function toggleFontSize() {
      bigFontSize.toggle();
      if (bigFontSize.value) {
        document.body.setAttribute('data-fontsize', 'large');
      } else {
        document.body.setAttribute('data-fontsize', 'small');
      }
    }
    return { showDialog, signUp, toggleFontSize, showBanner };
  },
};
</script>

<style lang="scss" scoped>
.welcome {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #1c1c1c;
  padding: 36px;

  h1 {
    margin-top: 68px;
    margin-bottom: 36px;
    margin-right: 64px;
    font-size: 32px;
    font-weight: 700;
    background-image: linear-gradient(45deg, #00a499, #003f3b);
    background-size: 100%;
    background-clip: text;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }

  p {
    color: rgba(white, 0.9);
    font-size: var(--normal-text-size);
    font-weight: 500;
  }

  .credits {
    color: rgba(#fff, 0.9);
    font-size: var(--smaller-text-size);
    font-weight: 500;
  }
}

.top-banner {
  background: #ffcc00;
  color: #222;
  padding: 12px;
  text-align: center;
  font-weight: bold;
}
</style>
